import { Routes } from '@angular/router';
import { RouterTools } from '@sol/components';
import { AiAssistantRouteId } from './models/ai-assistant-route-id';

export const aiAssistantPages: Routes = [
  RouterTools.ofRedirect(AiAssistantRouteId.app, AiAssistantRouteId.conversations),
  RouterTools.ofRedirect(AiAssistantRouteId.assistant, AiAssistantRouteId.conversations),
  RouterTools.ofLazy(AiAssistantRouteId.conversations, () =>
    import('./pages/ai-assistant-conversations-page/ai-assistant-conversations-page.component').then(
      m => m.AiAssistantConversationsPageComponent,
    ),
  ),
  RouterTools.ofLazy(AiAssistantRouteId.actions, () =>
    import('./pages/ai-assistant-actions-page/ai-assistant-actions-page.component').then(
      m => m.AiAssistantActionsPageComponent,
    ),
  ),
  RouterTools.ofLazy(AiAssistantRouteId.tools, () =>
    import('./pages/ai-assistant-tools-page/ai-assistant-tools-page.component').then(
      m => m.AiAssistantToolsPageComponent,
    ),
  ),
  RouterTools.ofLazy(AiAssistantRouteId.skills, () =>
    import('./pages/ai-assistant-skills-page/ai-assistant-skills-page.component').then(
      m => m.AiAssistantSkillsPageComponent,
    ),
  ),
  RouterTools.ofLazy(AiAssistantRouteId.dashboard, () =>
    import('./pages/ai-assistant-dashboard-page/ai-assistant-dashboard-page.component').then(
      m => m.AiAssistantDashboardPageComponent,
    ),
  ),
  RouterTools.ofLazy(AiAssistantRouteId.tracker, () =>
    import('./pages/ai-assistant-tracker-page/ai-assistant-tracker-page.component').then(
      m => m.AiAssistantTrackerPageComponent,
    ),
  ),
];

export const aiAssistantRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/ai-assistant-shell/ai-assistant-shell.component').then(m => m.AiAssistantShellComponent),
    children: aiAssistantPages,
  },
];
